<template>
  <div class="simple-mind-map-container">
    <div ref="mindMapContainerRef" class="mind-map-container" />
    <div class="mark" v-if="showMask"></div>
  </div>
</template>
<script>
import MindMap from 'simple-mind-map'
import Export from 'simple-mind-map/src/plugins/Export.js'
MindMap.usePlugin(Export)

export default {
  props: {
    mindData: {
      type: Object,
      default: () => {},
    },
    showMask: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mindMap: null,
      imgBase64: '',
      pageLoading: false,
      isLoaded: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.mindMap = new MindMap({
        readonly: true,
        selectTextOnEnterEditText: false,
        el: this.$refs['mindMapContainerRef'],
        data: this.mindData,
        initRootNodePosition: ['10%', 'center'],
        themeConfig: {
          lineColor: '#DDDDDD',
          showLineMarker: true,
          paddingX: 20,
          paddingY: 10,
          backgroundColor: '#fff',
          root: {
            fillColor: '#409EFF',
            color: '#fff',
            borderColor: 'transparent',
            borderWidth: 0,
            hoverRectColor: '#155AEF',
          },
          second: {
            fillColor: '#fff',
            color: '#409EFF',
            borderColor: '#409EFF',
            borderWidth: 1,
          },
          node: {
            fillColor: '#F1F6F8',
            color: '#6C757D',
            borderColor: 'transparent',
            borderWidth: 0,
          },
        },
      })
      this.mindMap.on('node_tree_render_end', () => {
        this.mindMap.view.fit()
        if(!this.isLoaded) {
          this.mindMap.execCommand('UNEXPAND_TO_LEVEL', 2)
          this.isLoaded = true
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.simple-mind-map-container {
  position: relative;
}
.mind-map-container {
  width: 100%;
  height: 700px;
}
.mind-map-img {
  width: 100%;
  height: 100%;
}
.loading-container {
  height: 400px;
  width: 100%;
}
.mark {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 700px;
  background-color: transparent;
}
</style>
